import { Container, LoadingSpinner } from "../styles/styles";
export const Loading = () => (
  <Container>
    <LoadingSpinner/>
  </Container>
);
